module.exports = require("vm");


//////////////////
// WEBPACK FOOTER
// external "vm"
// module id = 457
// module chunks = 0 1 2 3